<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
        <div class="card-header-actions">

          <CLink v-if="reload" class="card-header-action btn-minimize" v-on:click="tableReload">
            <CIcon name="cil-reload"/>
          </CLink>

        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="computedItems"
        :fields="fields"
        :items-per-page="100"
        :sorter="sorter"
        noItemsView="{ noResults: 'Durch Filter keine anzeigbaren Daten', noItems: 'noch keine Daten' }"
        pagination      
      >
        
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
        <template #functions="{item}">
          <td>
            <CButtonGroup>
              <CButton
                color="primary"
                variant="outline"
                square
                size="lg"
                @click="orderChangeAmount({item:item , amount:1})"
              >
                +
              </CButton>
              <CButton
                color="primary"
                variant="outline"
                square
                size="lg"
                @click="orderChangeAmount({item:item , amount:-1})"
              >
                -
              </CButton>
              <CButton
                v-if="approve"
                color="primary"
                variant="outline"
                square
                size="lg"
                @click="orderApprove({id:item.id})"
                :class="getClass(item.status)"
              >
                
              </CButton>
            </CButtonGroup>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'Table',
  props: {
    items: Array,
    fields: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    sorter: Boolean,
    approve: Boolean,
    reload: {
      type: Boolean,
      default: true
    },
    highlightRow:Array
  },
   
  methods: {
    ...mapActions(['orderChangeAmount','orderApprove','tableReload']),

    getClass(status) {
      return status === 'unbestätigt' ? 'icon-approve'  
                                      : 'icon-decline';
    },

    getBadge (status) {
      return status === 'unbestätigt' ? 'secondary'
        : status === 'im Warenkorb' ? 'warning'
          : status === 'bestellt' ? 'primary'
          : status === 'in Bearbeitung' ? 'primary'
            : status === 'geliefert' ? 'success' 
              : status === 'versendet' ? 'success' 
                : status === 'Fehler' ? 'danger' 
                  : 'secondary'
    }
  },
  
   computed: {
    computedItems() {
      
      if (typeof this.items !== 'undefined') {
        
        if (typeof(this.highlightRow)==='undefined') {

          return this.items.map(item => {
            return {
              ...item
            };
          });
        
        } else {
          
          return this.items.map(item => {
            return {
              ...item,
              _classes: [
                item._classes,
                this.highlightRow.includes(parseInt(item.id)) && "bg-info"
              ]
            };
          });

        }
      
      }
    }
  }
}
</script>
